import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ProcessBenefits = () => {
  const benefits = [
    {
      icon: 'ri-flashlight-line',
      title: 'Rapidez',
      description: 'Entregamos resultados en días, no semanas. La optimización de procesos acelera cada entrega sin sacrificar calidad.',
    },
    {
      icon: 'ri-eye-line',
      title: 'Claridad',
      description: 'Comunicación transparente en cada etapa. Entendemos que el lenguaje legal puede ser complejo, por eso lo simplificamos.',
    },
    {
      icon: 'ri-rocket-line',
      title: 'Eficiencia',
      description: 'Procesos optimizados que combinan lo mejor de la tecnología con la experiencia profesional de abogados.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Seguridad',
      description: 'Tus datos están protegidos con encriptación de nivel bancario. Cumplimos con todas las normativas de protección de datos.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Accesibilidad',
      description: 'Precios justos y transparentes. La tecnología nos permite ofrecer servicios legales de calidad a costos accesibles.',
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Soporte continuo',
      description: 'Atención personalizada antes, durante y después del servicio. Estamos aquí para resolver tus dudas.',
    },
  ];

  return (
    <section className="py-24 bg-primary-yellow">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl lg:text-6xl font-bold text-black mb-6">
            ¿Por qué elegir Bala Corp?
          </h2>
          <p className="text-xl text-gray-dark max-w-3xl mx-auto">
            Combinamos tecnología de punta con experiencia legal profesional
          </p>
        </motion.div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-black rounded-xl mb-6">
                <i className={`${benefit.icon} text-3xl text-primary-yellow`}></i>
              </div>
              <h3 className="text-2xl font-bold text-black mb-4">
                {benefit.title}
              </h3>
              <p className="text-gray-dark leading-relaxed">
                {benefit.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.6 }}
          className="text-center bg-black rounded-3xl p-12"
        >
          <h3 className="text-3xl lg:text-4xl font-bold text-white mb-4">
            ¿Listo para comenzar?
          </h3>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Únete a cientos de emprendedores y empresas que ya confían en Bala Corp para sus necesidades legales
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/servicios"
              className="bg-primary-yellow text-black px-10 py-4 rounded-full font-bold hover:bg-yellow-400 transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              Ver servicios
            </Link>
            <Link
              to="/contacto"
              className="bg-transparent border-2 border-white text-white px-10 py-4 rounded-full font-bold hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Contactar ahora
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ProcessBenefits;